import { gql } from '@apollo/client';
import { FACILITY_OFFERINGS_CORE } from '@pass-frontend/common/data-access';

const WITH_TIER_IDS_FRAGMENT = (withTierIds: boolean) => {
  if (withTierIds) {
    return gql`
      fragment withTierIds on FacilityOffering {
        tierIds
      }
    `;
  }
  return gql`
    fragment withTierIds on FacilityOffering {
      facilityId # no-op
    }
  `;
};

export const facilityOfferingsSearchQueryGql = (withTierIds = false) => gql`
  ${WITH_TIER_IDS_FRAGMENT(withTierIds)}
  ${FACILITY_OFFERINGS_CORE}
  query MATCH_OFFERING_FILTERS(
    $distanceKey: String
    $filterKeys: [String]
    $searchText: String
    $sort: Boolean
    $limit: Int
    $offset: Int
  ) {
    facilityOfferingsSearch(
      distanceKey: $distanceKey
      filterKeys: $filterKeys
      searchText: $searchText
      sort: $sort
      limit: $limit
      offset: $offset
    ) @client {
      totalCount
      matches {
        ...FacilityOfferingsCore
        ...withTierIds
      }
    }
  }
`;
